import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { CourierFileDetailApiAdapter } from '../adapters';
import { DeductPaymentRequest } from '../models';

export const useDeductPayment = (fileId: number) => {
  const { toast } = useToast();
  const { t } = useTranslation('codCourierFileDetail');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: DeductPaymentRequest) => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFileDetailApiAdapter(httpClient);
      return adapter.deductPayment(fileId, data);
    },
    onSuccess: () => {
      // Invalidar las queries relacionadas para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ['courier-cod-file', fileId] });
      queryClient.invalidateQueries({ queryKey: ['courier-cod-file-payments', fileId] });

      toast({
        title: t('deductPayment.success.title', 'Pago descontado exitosamente'),
        description: t('deductPayment.success.description', 'El descuento se ha aplicado al archivo correctamente'),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        t('deductPayment.error.unexpected', 'Ocurrió un error inesperado');

      toast({
        title: t('deductPayment.error.title', 'Error al descontar pago'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });

  return {
    deductPayment: mutation.mutate,
    deductPaymentAsync: mutation.mutateAsync,
    isDeducting: mutation.isPending,
  };
};
